import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, ArrowRight, Star, Award, Heart } from "lucide-react";
import { PopupModal } from "react-calendly";

function Hero() {
	const [openBooking, setOpenBooking] = useState(false);

	return (
		<section className="relative py-32 md:py-44 overflow-hidden bg-gray-50">
			{/* Hero Background */}
			<div
				className="absolute inset-0 bg-gradient-to-b from-white via-gray-50 to-white opacity-100"
				style={{
					maskImage:
						"linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))",
					WebkitMaskImage:
						"linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))",
				}}
			>
				{" "}
				<div
					className="absolute inset-0 bg-cover bg-center opacity-60" // Increased opacity from 20% to 60%
					style={{
						backgroundImage: "url('/images/hero_room.jpg')",
					}}
				/>
			</div>

			<div className="container mx-auto px-6 relative z-10">
				<div className="flex flex-col items-center text-center space-y-10">
					{/* Headline with Animation */}
					<motion.div
						initial={{ opacity: 0, y: -50 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.5 }}
						className="max-w-4xl"
					>
						<h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
							<span className="text-primary">Custom Window Shades</span>
							<br />
							Designed for Your Windows
						</h1>
						<p className="text-xl md:text-2xl font-medium mb-8">
							Premium quality, perfect fit, and expert guidance - all at 50%
							less than retail
						</p>
					</motion.div>

					{/* CTAs */}
					<div className="flex flex-col sm:flex-row gap-6">
						<motion.div
							whileHover={{ scale: 1.05 }}
							whileTap={{ scale: 0.95 }}
							initial={{ opacity: 0, y: 50 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.3, delay: 0.3 }}
						>
							<Link
								to="/shop"
								className="inline-flex items-center px-8 py-4 border-2 border-primary bg-primary hover:bg-primary/90 text-white font-semibold rounded-xl shadow-lg transition-colors"
							>
								<span>Shop Custom Shades</span>
								<ArrowRight className="ml-2" />
							</Link>
						</motion.div>
						<motion.div
							whileHover={{ scale: 1.05 }}
							whileTap={{ scale: 0.95 }}
							initial={{ opacity: 0, y: 50 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.3, delay: 0.5 }}
						>
							<button
								onClick={() => setOpenBooking(true)}
								className="inline-flex items-center px-8 py-4 bg-transparent border-2 border-primary text-primary hover:bg-white/10 font-semibold rounded-xl transition-colors"
							>
								<span>Book a Free Consulation</span>
								<ArrowRight className="ml-2" />
							</button>
						</motion.div>
					</div>

					{/* Trust Badges */}
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ duration: 0.5, delay: 0.7 }}
						className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8"
					>
						{[
							{
								text: "4.9/5 Customer Rating",
								icon: <Star className="w-5 h-5" />,
							},
							{
								text: "5-Year Warranty",
								icon: <CheckCircle className="w-5 h-5" />,
							},
							{ text: "Made in Toronto", icon: <Award className="w-5 h-5" /> },
							{ text: "Free Samples", icon: <Heart className="w-5 h-5" /> },
						].map((badge, i) => (
							<div
								key={i}
								className="flex items-center gap-2 bg-black/10 backdrop-blur-sm px-4 py-2 rounded-full text-sm"
							>
								{badge.icon}
								<span>{badge.text}</span>
							</div>
						))}
					</motion.div>
				</div>
			</div>

			<PopupModal
				url="https://calendly.com/offcutshades"
				rootElement={document.getElementById("root")}
				open={openBooking}
				onModalClose={() => setOpenBooking(false)}
			/>
		</section>
	);
}

export default Hero;
